import axios from 'axios';
import api from './ApiAuthService';

export default class Partnerships {

  static async post(dados: any) {
    try {
      const response = await api.post("/posts/partnerships", dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async update(id: number, dados: any) {
    try {
      const response = await api.post(("/posts/partnerships/" + id ), dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}